import clsx from "clsx";
import Link from "next/link";
import { useRouter } from "next/navigation";
import posthog from "posthog-js";
import { useHotkeys } from "react-hotkeys-hook";
import Tooltip from "~/designSystem/components/Tooltip";

import { POSTHOG_EVENTS } from "~/core/constants/analytics";
import { routes } from "~/core/constants/routes";
import Logo from "~/core/ui/Logo";
import {
  NavigationMenu,
  NavigationMenuItem,
  NavigationMenuLink,
  NavigationMenuList,
  navigationMenuTriggerStyle,
} from "~/core/ui/Navigation";

import useUserSession from "~/lib/organizations/hooks/use-user-session";

const SiteNavbar = () => {
  const router = useRouter();
  const { userSession } = useUserSession();

  useHotkeys(
    "o",
    () => {
      router.push(userSession ? routes.appDefaultLanding : routes.auth.signIn);
    },
    [userSession],
  );

  return (
    <div>
      <header
        className={clsx(
          " h-10  items-center space-x-1 bg-base-12 p-1 fixed inset-x-3 top-4 z-50 mx-auto flex max-w-4xl transform-gpu animate-slide-down-fade justify-center overflow-hidden rounded-md border border-transparent w-fit  transition-all duration-300 ease-in will-change-transform",
        )}
      >
        <NavigationMenu>
          <NavigationMenuList>
            <NavigationMenuItem>
              <Link href="/" passHref>
                <NavigationMenuLink className={navigationMenuTriggerStyle()}>
                  <Logo className="h-5 w-auto" />
                </NavigationMenuLink>
              </Link>
            </NavigationMenuItem>

            <Tooltip
              side="top"
              contentText="Open"
              shortcutKey={{
                keys: [{ type: "letter", value: "O" }],
              }}
            >
              <NavigationMenuItem>
                <Link
                  href={
                    userSession ? routes.appDefaultLanding : routes.auth.signIn
                  }
                  className="hover:text-inherit"
                  passHref
                  onClick={() => {
                    if (userSession) return;
                    posthog.capture(POSTHOG_EVENTS.HOMEPAGE.SIGN_IN_CLICKED);
                  }}
                >
                  <NavigationMenuLink className={navigationMenuTriggerStyle()}>
                    Open App
                  </NavigationMenuLink>
                </Link>
              </NavigationMenuItem>
            </Tooltip>
          </NavigationMenuList>
        </NavigationMenu>
      </header>
    </div>
  );
};

export default SiteNavbar;
